export default __webpack_public_path__ + "static/Group 24-dc7887aeec23ff11eb086e1aab5a195c.jpg";